import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  nextButton: {
    id: 'learn.sequence.navigation.next.button',
    defaultMessage: 'Next',
    description: 'Button to advance to the next section',
  },
  nextUpButton: {
    id: 'learn.sequence.navigation.next.up.button',
    defaultMessage: 'Next Up: {title}',
    description: 'Button to advance to the next section, with title',
  },
  previousButton: {
    id: 'learn.sequence.navigation.previous.button',
    defaultMessage: 'Previous',
    description: 'Button to return to the previous section',
  },
  unitButtonComplete: {
    id: 'unit.button.complete',
    defaultMessage: 'Rozdział został ukończony',
    description: 'Message showed when unit is complete',
  },
  unitButtonNotFinished: {
    id: 'unit.button.not.finished',
    defaultMessage: 'Rozdział nie został jeszcze ukończony',
    description: 'Message shown when unit is not finished yet'
  },
});

export default messages;
